<div #actions fxLayout="column">
  <div class="button-row" fxLayout="row">
    <div
      #previousButton
      (click)="previous()"
      [ngClass]="{ disabled: step <= minStep }"
      class="button previous no-select"
      fxFlex
      fxLayout="row">
      <div><i class="arrow-left"></i></div>
      <div class="button-text">{{ 'STEPCONTAINER.PREVIOUSSTEP' | translate }}</div>
    </div>
    <div
      #nextButton
      (click)="next()"
      (mouseenter)="showNotificationIfNeeded()"
      (mouseleave)="hideNotification()"
      [ngClass]="{ disabled: step >= maxStep || blocked }"
      class="button next no-select"
      fxFlex
      fxLayout="row"
      id="nextButton">
      <div *ngIf="step !== stepService.maxStep - 1" class="button-text">{{ 'STEPCONTAINER.NEXTSTEP' | translate }}</div>
      <div *ngIf="step === stepService.maxStep - 1" class="button-text">{{ 'STEPCONTAINER.SUMMARY' | translate }}</div>
      <i class="arrow-right"></i>
    </div>
  </div>
</div>
